import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "po-summary-item"
};
const _hoisted_2 = {
  class: "order-summary-multiple-po-number notranslate"
};
const _hoisted_3 = {
  class: "po-summary-left-column"
};
const _hoisted_4 = {
  class: "order-summary-multiple-po-item-line-price"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_6 = {
  class: "po-item-details"
};
const _hoisted_7 = {
  key: 0,
  class: "po-item-detail"
};
const _hoisted_8 = {
  class: "po-detail-type"
};
const _hoisted_9 = {
  class: "po-detail-values"
};
const _hoisted_10 = {
  key: 1,
  class: "po-item-detail"
};
const _hoisted_11 = {
  class: "detail-total-type"
};
const _hoisted_12 = {
  class: "po-detail-values"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 2,
  class: "po-item-detail"
};
const _hoisted_15 = {
  class: "detail-total-type"
};
const _hoisted_16 = {
  class: "po-detail-values"
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  class: "po-item-detail"
};
const _hoisted_19 = {
  class: "detail-total-type"
};
const _hoisted_20 = {
  class: "po-detail-values"
};
const _hoisted_21 = {
  class: "po-item-detail"
};
const _hoisted_22 = {
  class: "detail-total-type"
};
const _hoisted_23 = {
  class: "po-detail-values"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ChevronIcon = _resolveComponent("ChevronIcon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "order-summary-multiple-po-item",
    onClick: _cache[1] || (_cache[1] = $event => $options.toggleDropdowns())
  }, [_createElementVNode("span", _hoisted_2, _toDisplayString($props.poData.poNumber), 1), _createElementVNode("span", _hoisted_3, [_createElementVNode("span", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.poData.totalsByCurrency, (currencyEntry, idx) => {
    return _openBlock(), _createElementBlock("span", {
      key: idx
    }, [_createTextVNode(_toDisplayString(currencyEntry.total) + " " + _toDisplayString(currencyEntry.currency), 1), _hoisted_5]);
  }), 128))]), _createElementVNode("span", {
    class: _normalizeClass(["toggle-button", {
      'expanded': $data.isExpanded
    }]),
    tabindex: "0",
    onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers($event => $options.toggleDropdowns(), ["prevent"]), ["enter"]))
  }, [_createVNode(_component_ChevronIcon)], 34)])]), _withDirectives(_createElementVNode("div", _hoisted_6, [$options.displayFee ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString($options.getLabel('movSurcharge')), 1), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.poData.totalsByCurrency, (currencyEntry, idx) => {
    return _openBlock(), _createElementBlock("span", {
      key: 'movSurcharge-' + currencyEntry.currency
    }, _toDisplayString(currencyEntry.fee) + " " + _toDisplayString(currencyEntry.currency), 1);
  }), 128))])])) : _createCommentVNode("", true), $options.displayDiscount ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString($options.getLabel('orderreview.discount')), 1), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.poData.totalsByCurrency, (currencyEntry, idx) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: 'discount-' + currencyEntry.currency
    }, [currencyEntry.discount ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(currencyEntry.discount) + " " + _toDisplayString(currencyEntry.currency), 1)) : _createCommentVNode("", true)], 64);
  }), 128))])])) : _createCommentVNode("", true), $options.displaySurcharge ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString($options.getLabel('surcharges')), 1), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.poData.totalsByCurrency, (currencyEntry, idx) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: 'surcharge-' + currencyEntry.currency
    }, [currencyEntry.surcharge ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(currencyEntry.surcharge) + " " + _toDisplayString(currencyEntry.currency), 1)) : _createCommentVNode("", true)], 64);
  }), 128))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString($options.getLabel('subtotal')), 1), _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.poData.totalsByCurrency, (currencyEntry, idx) => {
    return _openBlock(), _createElementBlock("span", {
      key: 'subtotal-' + currencyEntry.currency
    }, _toDisplayString(currencyEntry.subtotal) + " " + _toDisplayString(currencyEntry.currency), 1);
  }), 128))])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString($options.getLabel('tax')), 1), _createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.poData.totalsByCurrency, (currencyEntry, idx) => {
    return _openBlock(), _createElementBlock("span", {
      key: 'tax-' + currencyEntry.currency
    }, _toDisplayString(currencyEntry.tax) + " " + _toDisplayString(currencyEntry.currency), 1);
  }), 128))])])], 512), [[_vShow, $data.isExpanded]])]);
}